import React from 'react';
import { useTranslation } from 'react-i18next';
import {currencyFormat, EMPTY_VALUES} from '../../../../../../Apis/functions';
import {TYPE_PAYMENT} from '../../Model/Model';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle: Full Stack Developer - IBL
 * @Email: clopez@ibl.mx
 *
 */
const AmountComponent = ({ folio, subtotal, discount, penalty, total, paymentType = '', isPaid = false, className = "col-6" }) => {
    const { t } = useTranslation();

    const isCondonation = paymentType != '' && paymentType === TYPE_PAYMENT.CONDONATION;
    const totalCondonacion = ( subtotal - discount ) + penalty;
    return (
        <div className={className}>
            <div className="d-flex justify-content-between align-items-center pb-2">
                <div className="fs-14px ibl-font-w-600 font-color-shades-700">{t("summary")}</div>
                <div className="fs-14px ibl-font-w-400 font-color-shades-700">{`${t("ticket")}  #${folio || EMPTY_VALUES.DEFAULT}`}</div>
            </div>
            <div className="row d-flex justify-content-between align-items-center pb-2">
                <div className="col-8 px-0 fs-14px ibl-font-w-300 font-color-shades-800">{t("fine")}</div>
                <div className="col-2 d-flex justify-content-end fs-14px ibl-font-w-300 font-color-shades-800">{`$`}</div>
                <div className="col-2 px-0 d-flex justify-content-end fs-14px ibl-font-w-300 font-color-shades-800">{`${ currencyFormat(subtotal) || EMPTY_VALUES.DEFAULT_NUMBER}`}</div>
            </div>
            <div className="row d-flex justify-content-between align-items-center pb-2">
                <div className="col-8 px-0 fs-14px ibl-font-w-300 font-color-shades-800">{t("penalty")}</div>
                <div className="col-2 d-flex justify-content-end fs-14px ibl-font-w-300 font-color-shades-800">{`+ $`}</div>
                <div className="col-2 px-0 d-flex justify-content-end fs-14px ibl-font-w-300 font-color-shades-800">{`${currencyFormat(penalty) || EMPTY_VALUES.DEFAULT_NUMBER}`}</div>
            </div>

            <div className="border-bottom-shades-150 my-2" />
            <div className="row d-flex justify-content-between align-items-center pb-2">
                <div className="col-8 px-0 fs-14px ibl-font-w-300 font-color-shades-800">{t("subtotal")}</div>
                <div className="col-2 d-flex justify-content-end fs-14px ibl-font-w-300 font-color-shades-800">{`$`}</div>
                <div className="col-2 px-0 d-flex justify-content-end fs-14px ibl-font-w-300 font-color-shades-800">{`${ currencyFormat(subtotal + penalty) || EMPTY_VALUES.DEFAULT_NUMBER}`}</div>
            </div>
            <div className="row d-flex justify-content-between align-items-center pb-2">
                <div className="col-8 px-0 fs-14px ibl-font-w-300 font-color-shades-800">{t("discount")}</div>
                <div className="col-2 d-flex justify-content-end fs-14px ibl-font-w-300 font-color-shades-800">{`- $`}</div>
                <div className="col-2 px-0 d-flex justify-content-end fs-14px ibl-font-w-300 font-color-shades-800">{`${currencyFormat(discount) || EMPTY_VALUES.DEFAULT_NUMBER}`}</div>
            </div>
            {isCondonation &&
                <>
                    <div className="row d-flex justify-content-between align-items-center pb-2">
                        <div className="col-8 px-0 fs-14px ibl-font-w-300 font-color-shades-800">{t("CONDONATION")}</div>
                        <div className="col-2 d-flex justify-content-end fs-14px ibl-font-w-300 font-color-shades-800">{`- $`}</div>
                        <div className="col-2 px-0 d-flex justify-content-end fs-14px ibl-font-w-300 font-color-shades-800">{`${currencyFormat(isPaid ? totalCondonacion :  total) || EMPTY_VALUES.DEFAULT_NUMBER}`}</div>
                    </div>
                </>
            }
            <div className="border-bottom-shades-150 my-2" />
            <div className="row d-flex justify-content-between align-items-center pb-2">
                <div className="col-8 px-0 fs-16px ibl-font-w-600 font-color-shades-800">{t("total")}</div>
                <div className="col-2 d-flex justify-content-end fs-16px ibl-font-w-600 font-color-shades-800">{`$`}</div>
                <div className="col-2 px-0 d-flex justify-content-end fs-16px ibl-font-w-600 font-color-shades-800">{`${currencyFormat(isCondonation ? 0.0 : total) || EMPTY_VALUES.DEFAULT_NUMBER}`}</div>
            </div>
        </div>
    );

}
export default AmountComponent
